module.exports = __webpack_public_path__ + "img/children-hiking-RF93HEA-scaled.7b59bc8c.jpg";